module.exports = __webpack_public_path__ + "media/images/new_home/exit_white-16ff579a009bdcaeb269a9a706c4a1c0.png";